import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "name", "role", "count"]

  connect() {
    this.testimonials = [
      {
        text: "After evaluating several options, JetRockets was the clear winner. They followed through exactly to spec with daily updates and speed beyond what was promised. The engineers were self-guided and required zero oversight.",
        name: "Ryan Kulp",
        role: "Operator, Fera.ai"
      },
      {
        text: "JetRockets is so much more than a dev team — they are a core part of Safari Portal and of our family. They truly care about the product and its success.",
        name: "Rachel West",
        role: "Founder & CEO, Safari Portal"
      },
      {
        text: "They bring a lot of deep Rails and architecture experience to the table.",
        name: "Josh Dzielak",
        role: "Co-Founder & CTO, Orbit"
      },
      {
        text: "Their team delivers on time and is very communicative. They’ve taken ownership of the project when necessary; they are very responsible.",
        name: "Nir Badichi",
        role: "Product Manager, eBay"
      }
    ]
    this.currentIndex = 0
    this.startAutoSlide()
  }

  disconnect() {
    this.stopAutoSlide()
  }

  startAutoSlide() {
    this.autoSlideInterval = setInterval(() => this.next(), 5000)
  }

  stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval)
    }
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.testimonials.length
    this.updateDisplay()
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.testimonials.length) % this.testimonials.length
    this.updateDisplay()
  }

  updateDisplay() {
    const testimonial = this.testimonials[this.currentIndex]
    this.textTarget.textContent = testimonial.text
    this.nameTarget.textContent = testimonial.name
    this.roleTarget.textContent = testimonial.role
    this.countTarget.textContent = `${this.currentIndex + 1} / ${this.testimonials.length}`
  }
}
